import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import { ApiVisa, BaseApiTemplateService, Core2Config } from "../../shared";

@Injectable({providedIn: "root"})
export class MembershipCSVTemplateService extends BaseApiTemplateService<any>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'membership';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'membership';
    this.httpClient = http;
  }

  async downloadCSVTemplate(authorization: string, apiVisa: ApiVisa){
    const CSV_URL = apiVisa.api_domain_url + this.endpoint_path + '/import-file-hdrs/download-master-data-template';
    const headers = new HttpHeaders({ "authorization": authorization, "tenantCode" : apiVisa.tenantCode });
    const fileBlob = await this.httpClient
      .get(CSV_URL, { headers, responseType: 'blob' })
      .toPromise();
    return fileBlob;
  }
}
